/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { Clear, ErrorOutline } from "@mui/icons-material";
import { Paper, Typography, FormLabel, Divider, Tooltip, IconButton, Box, TextField, MenuItem, Button } from "@mui/material";
import { useStyles } from "../../util/ComponentStyles";
import { ThemeProvider } from "@mui/material/styles";
import { theme, customStyles5 } from "../../util/TableStyles"
import { noDataComponent } from "../../util/DataObject"
import DataTable from "react-data-table-component";

const LimitsBalanceDetail = (props) => {
  const clasess = useStyles();
  const history = useHistory();
  const [content, setContent] = useState({});
  const [entity_uuid, setEntityUuid] = useState("");
  const [osSpace, setOsSpace] = useState("");
  const [activeCustomer, setActiveCustomer] = useState(true);
  const [activeSpace, setActiveSpace] = useState(true);
  const [catalogLevel, setCatalogLevel] = useState([]);
  const [level, setLevel] = useState("");
  const [upgrade, setUpgrade] = useState(false);

  useEffect(() => {
    if (props.next === "update") {
      props.updateNext(null);
    }
    setContent(props.widgets[0].content)
    if(props.widgets[0].content['entity_uuid']){
      setEntityUuid(props.widgets[0].content['entity_uuid'])
    }
    if(props.widgets[0].request['entity']){
      setOsSpace(props.widgets[0].request['entity']['uuid'])
    }
  }, [props.widgets[0].content]);

  const hasAction = (action) => {
    return props.widgets[0].config?.actions?.indexOf(action) > -1;
  };

  const subTypes = [
    {key: "cashin", label: "Cashin"},
    {key: "global", label: "Global"},
    {key: "transfer-credit", label: "Transferencias de crédito"},
    {key: "transfer-debit", label: "Transferencias de débito"},
    {key: "atm", label: "Cajero Automático"},
    {key: "ecommerce", label: "Ecommerce"},
    {key: "pos", label: "Punto de Venta"},
  ]

  const type = [
    {key: "balance", label: "Balance"},
    {key: "moneyin", label: "MoneyIn"},
    {key: "moneyout", label: "MoneyOut"},
  ]
  const frecuency = [
    {key: "daily", label: "Diario"},
    {key: "monthly", label: "Mensual"},
  ]

  const columns = []
  if(content){
    columns.push(
      { selector: (row) => type.map((i) => {if(i.key === row.type){return i.label}}), name: "Tipo", width:"10%", wrap: true, sortable: true },
      { selector: (row) => subTypes.map((i) => {if(i.key === row.subType){return i.label}}), name: "Sub-Tipo", width: content["percentage"] ? "15%" : "20%", wrap: true, sortable: true },
      { selector: (row) => frecuency.map((i) => {if(i.key === row.frecuency){return i.label}}), name: "Frecuencia", width:"11%", wrap: true, sortable: true },
      { selector: (row) => row.balance, name: "Balance", width:"13%", wrap: true, sortable: true },
      { selector: (row) => row.balance_udi, name: "Balance (Udi)", width:"13%", wrap: true, sortable: true },
      { selector: (row) => row.limit, name: "Límite", width:"14%", wrap: true, sortable: true },
      { selector: (row) => row.limit_udi, name: "Límite (Udi)", width:"14%", wrap: true, sortable: true },
    )
  }
  if(content["percentage"]){
    columns.push(
      { selector: (row) => row.percentage || row.percentage === 0 ? row.percentage+"%" : "N/A", name: "%", width:"9%", wrap: true, sortable: true, center: true },
    )
  }

  const colapseCustomer = () => {
    activeCustomer ? setActiveCustomer(false) : setActiveCustomer(true);
  }
  const colapseSpace = () => {
    activeSpace ? setActiveSpace(false) : setActiveSpace(true);
  }

  const getCatalog = async () => {
    props.changeLoader(true);
    let data = {
      catalog: {
        id: "customer_limits",
      },
    };
    
    let request = await API.service('getCatalog', data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == 'OK') {
      setCatalogLevel(request.data.data.catalog)
      setUpgrade(true)
    }
    props.changeLoader(false);
  }

  const levelUpgrade = async () => {
    let subProduct = await getSubProduct()
    if(subProduct){    
      let data = {
        entity: {
          uuid: entity_uuid,
          type: "customer"
        },
        new_space_level: {
          profile: subProduct,
          type: "1"
        },
        entity_type: "customer"
      };
  
      let request = await API.service('spaceLevelUpgrade', data, props.pos, props.changeAlert, props.changeLoader, history);
      if (request.status == 200 && request.data.data.response == 'OK' ) {
        setUpgrade(false)
        setLevel(data.new_space_level.profile)
        await reloadData()
        props.changeAlert(true, 'success', 'Nivel de cuenta creado con éxito');
      }
      setUpgrade(false)
      props.changeLoader(false);
    }
  }

  const getSubProduct = async () => {
    let data = {
      uuid: entity_uuid,
      space: osSpace
    }
    props.changeLoader(true);
    let request = await API.service('getSubProduct', data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == 'OK' ) {
      return request.data.data.content
    } else {
      props.changeAlert(true, 'error', request.data.code + ': ' + request.data.message);
      props.changeLoader(false);
      return null
    }
  }

  const reloadData = async () => {
    props.changeLoader(true);
    let request = await API.service( "limitsBalance", props.widgets[0].request, props.pos, props.changeAlert, props.changeLoader, history);
    if ( request.status === 200 && request.data.data.response === "OK") {
      let widg = request.data.data.widget[0].content;
      setContent(widg)
    } else {
      let detail = request.data.data.message;
      props.changeAlert(true, "error", "Error al consultar límites, " + detail);
    }
    props.changeLoader(false);
  };

  const selectLevel = () => {
    return (
      <Box width={250} display={"flex"} alignItems={"center"}>
        <TextField  
          label={level} value={"-1"} select onChange={levelUpgrade.bind(this)} size="small" fullWidth >
            <MenuItem value={"-1"} disabled>Seleccione</MenuItem>
            {catalogLevel?.map((item, index) => {
              if(!(item.v.includes("loan"))){
                  return <MenuItem key={`level-${index}`} value={item.k}>
                    {item.k}
                  </MenuItem>
                }})
            }                 
        </TextField>
        <Tooltip title="Cancelar">
          <IconButton  onClick={cancel.bind(this)}>
            <Clear sx={{padding: 1, borderRadius: 2, boxSizing: "content-box", color: "white", backgroundColor: "#3743aa" }}/>
          </IconButton>
        </Tooltip>              
      </Box>
    )
  }

  const cancel = () => {
    setUpgrade(false)
  }

  return (
    <Paper className={clasess.limitsDetail}>
      <Typography
        component="div"
        children={
          <div className={clasess.titleTable}>
            <h2 className={clasess.titleH2}>             
              <ErrorOutline className={clasess.iconTitle} />
              Detalle consulta de límites
            </h2>
          </div>
        }
      />

      {content["customer"] &&
        <ThemeProvider theme={theme}>
          <Box display={"flex"} justifyContent={"space-between"} pr={3} alignItems={"center"}>
            <FormLabel component="legend" style={{fontSize:"16px", fontStyle: "italic", padding: "25px 30px", width: "inherit"}}>{!activeCustomer ? "Ver " : "Ocultar "}Cliente <i className={!activeCustomer ? `tap ibon-chevron-down`: `tap ibon-chevron-up`} onClick={colapseCustomer.bind(this, false)}/>
            </FormLabel>
            {hasAction('createLimits') && !upgrade && content["customer"].length === 0 && 
              <Button variant="contained" onClick={levelUpgrade.bind(this)}>Crear límites</Button>
            }
            {upgrade && selectLevel()}
          </Box>
          {activeCustomer &&
            <DataTable
              columns={columns}
              data={content["customer"]}        
              customStyles={customStyles5}
              noDataComponent={noDataComponent}       
            />          
          }
        <Divider style={{width: "96%", margin: "auto"}} />
        </ThemeProvider>
      }
      {content["space"] &&
        <ThemeProvider theme={theme} >
          <FormLabel component="legend" style={{fontSize:"16px", fontStyle: "italic", padding: "25px 30px"}}>{!activeSpace ? "Ver " : "Ocultar "}Espacios <i className={!activeSpace ? `tap ibon-chevron-down`: `tap ibon-chevron-up`} onClick={colapseSpace.bind(this, false)}/></FormLabel>
          {activeSpace &&
            <DataTable
              columns={columns}
              data={content["space"]}        
              customStyles={customStyles5}
              noDataComponent={noDataComponent}       
            />
          }
        </ThemeProvider>     
      }
      
    </Paper>
  );
};

export default LimitsBalanceDetail;
